<script lang="ts" setup>
  import { computed, ref } from 'vue';
  import { useShared, useAuthenticated, useHttpClient, useRoute } from '@othercommerce/foundation';

  const emit = defineEmits([
    'saved',
  ]);

  const route = useRoute();
  const shared = useShared();
  const session = useAuthenticated();
  const http = useHttpClient();
  const create = ref(false);

  const options = computed(() => {
    return shared.value.wishlists.map((wishlist) => {
      return {
        label: wishlist.label,
        value: wishlist.value,
      };
    });
  });

  function handleSubmit(data: any) {
    return http.post(route('web.cart.wishlist.store', { wishlist: data.wishlist }), data).then(() => {
      emit('saved');
    });
  }
</script>
<template>
  <FormController v-slot="{ data, processing }" class="wishlist-cart-picker" @submit="handleSubmit">
    <section class="wishlist-cart-picker__wrapper">
      <div v-if="session">
        <SfFormSelect :label="$t('SHOP.CART.LABEL.SELECT_WISHLIST')" :options="options" name="wishlist" required />
      </div>
      <div v-else class="wishlist-cart-picker__authentication">
        <p>{{ $t('SHOP.CART.MESSAGE.WISHLIST_AUTHENTICATION_NOTICE') }}</p>
      </div>
    </section>
    <footer class="wishlist-cart-picker__footer">
      <template v-if="session">
        <SfButton @click.prevent="create = true">
          <template #before>
            <SfIconPlus aria-hidden="true" />
          </template>
          {{ $t('SHOP.CART.ACTION.CREATE_NEW_WISHLIST') }}
        </SfButton>
        <SfButton :disabled="!data.wishlist" :loading="processing" primary type="submit">
          {{ $t('SHOP.ACTION.SAVE') }}
        </SfButton>
      </template>
      <template v-else>
        <SfButton :href="$route('web.account.session.create')" primary>
          {{ $t('SHOP.AUTH.ACTION.SIGN_IN') }}
        </SfButton>
      </template>
    </footer>
  </FormController>
  <WishlistEditModal v-model:open="create" @saved="create = false" />
</template>
<style lang="scss">
  .wishlist-cart-picker {
    &__wrapper {
      margin: 1rem 0;
    }

    &__authentication {
      color: var(--sf-status-color-danger);
      align-items: center;
    }

    &__footer {
      display: flex;
      justify-content: flex-end;
      gap: 1rem;
    }
  }
</style>
